import { Helmet } from 'react-helmet-async';

export function PrivacyPage() {
  return (
    <>
      <Helmet>
        <title>Política de Privacidad - LyricsHub</title>
      </Helmet>
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold text-text-primary mb-6">Política de Privacidad</h1>
        <div className="prose prose-invert max-w-none space-y-4 text-text-secondary text-sm leading-relaxed">
          <p>Última actualización: {new Date().getFullYear()}</p>

          <h2 className="text-lg font-semibold text-text-primary mt-8">
            1. Información que Recopilamos
          </h2>
          <p>
            Recopilamos información que nos proporcionas directamente: email, nombre de usuario, y
            preferencias de uso. También recopilamos datos de uso como páginas visitadas y búsquedas
            realizadas.
          </p>

          <h2 className="text-lg font-semibold text-text-primary mt-8">2. Uso de la Información</h2>
          <p>
            Utilizamos la información para proporcionar y mejorar el servicio, personalizar tu
            experiencia, y comunicarte actualizaciones relevantes.
          </p>

          <h2 className="text-lg font-semibold text-text-primary mt-8">3. Protección de Datos</h2>
          <p>
            Las contraseñas se almacenan hasheadas. Las IPs se anonimizan mediante hash SHA-256. No
            vendemos ni compartimos datos personales con terceros.
          </p>

          <h2 className="text-lg font-semibold text-text-primary mt-8">4. Cookies</h2>
          <p>
            Utilizamos cookies técnicas necesarias para el funcionamiento del servicio
            (autenticación, preferencias de tema e idioma).
          </p>

          <h2 className="text-lg font-semibold text-text-primary mt-8">5. Derechos del Usuario</h2>
          <p>
            Puedes solicitar la eliminación de tu cuenta y datos en cualquier momento desde la
            configuración de tu perfil o contactando a soporte@lyricshub.com
          </p>
        </div>
      </div>
    </>
  );
}
